import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { SpaResourceMetricsControllerWithActions } from './main.tsx';

export const SpaTransitionResources = withAnalyticsEvents()(
	SpaResourceMetricsControllerWithActions,
);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { setPrefetchStartMark } from './utils/prefetch-timing';
